import axiosx from '../axios/index';
import axios from 'axios';

export async function fetchCustomer(phoneNumber) {
  const url = `/customer?phoneLocal=${phoneNumber}`;

  try {
    const data = await axiosx.get(url);

    // if (data?.data?.success) {
    //   return data?.data;
    // } else if (data?.data?.success === false) {
    //   return data?.data;
    // } else {
    //   return 'error';
    // }
    return data;
  } catch (error) {
    return { success: false, error };
  }
}

export async function fetchCustomerZoho(phoneNumber) {
  const url = `/ticket/contacts/${phoneNumber}`;

  try {
    const data = await axiosx.get(url);

    // if (data?.data?.success) {
    //   return data?.data;
    // } else if (data?.data?.success === false) {
    //   return data?.data;
    // } else {
    //   return 'error';
    // }
    return data;
  } catch (error) {
    return { success: false, error };
  }
}

export async function createService(data) {
  const url = `/customer/createService`;
  const res = await axiosx
    .post(url, {
      status: data.status,
      serviceRequestType: data.serviceRequestType,
      accountCode: data.accountCode,
      accountCodeERP: data.accountCodeERP,
      accountType: data.accountType,
      requestType: data.requestType,
      clientName: data.clientName,
      clientNumber: data.clientNumber,
      phone: data.phone,
      city: data.city,
      suburb: data.suburb,
      cf_nw_aljhaz: data.cf_nw_aljhaz,
      quantity: data.quantity,
      technical: data.technical,
      cf_nw_alwasf: data.cf_nw_alwasf,
      notes: data.notes,
    })
    .then((ree) => ree)
    .catch((err) => err.response);
  if (res?.data?.success) {
    return res?.data;
  } else if (res?.data?.success === false) {
    return res?.data;
  } else {
    return 'error';
  }
}

export async function sendSMS(message, phonenumber) {
  const url = `https://sms-hommer.altaqnya.com.ly/sms/send`;
  try {
    const res = await axios
      .post(url, {
        name: 'test',
        message,
        phonenumber,
      })
      .then((ree) => ree)
      .catch((err) => err.response);
    return { success: true };
  } catch (error) {
    return { success: false, error: error };
  }
}
